import Vue from 'vue'
import Algolia from '@/components/Algolia/App.vue'
import {ready} from '@/shared'

ready(function () {
  new Vue({ // eslint-disable-line no-new
    el: '#searchAlgolia',

    components: {
      Algolia
    },

    render: h => h('Algolia')
  })
})



// WEBPACK FOOTER //
// ./src/algolia.js